<template>
  <div>
    <div v-for="(item, i) in actions" :key="i">
      <v-btn @click="move" class="md:flex justify-start w-full" text>
        {{ item.action }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      actions: [
        {
          action: "External",
        },
        {
          action: "Send Notification",
        },
        {
          action: "Change Status",
        },
        {
          action: "Send Email",
        },
      ],
    };
  },
  methods: {
    close() {},
    move() {
      this.close();
    },
  },
};
</script>
